import React, {useState} from 'react';
import {useAsync} from "react-async";
import {httpClient} from '../service';
import {ActionResult, HttpMethod} from '../model';
import ErrorPage from '../shared/ErrorPage';
import {TermsEntity} from '../model/TermsEntity';
import parse from 'html-react-parser';
import {Button, Modal} from "react-bootstrap";

const TermsModal = () => { // 추가
    const [show, setShow] = useState(false);
    const url = `infos/terms/personal`;
    const options = {promiseFn: httpClient, method: HttpMethod.GET, url};
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);
    if(isLoading) return null;
    if(error) return <ErrorPage />
    if (!act) return null;
    if (!act.result) return <ErrorPage msg={act.errorMsg} code={act.errorCode}/>;

    //setShow(true);
    const model: TermsEntity = act?.data;
    const handleClose = (e:any) => {
        e.preventDefault();
        setShow(false);
    }
    const handleShow = (e:any) => {
        e.preventDefault();
        setShow(true);
    }
    const content = model.content === undefined ? '' : model.content;
    return (
        <>
            <p className="mg-md comment">* 문의시 개인정보 수집 및 이용에 동의하신 것으로 간주합니다. [<a href="handleShow" onClick={handleShow}>약관보기</a>]</p>
            <Modal show={show} onHide={() => handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>개인정보 수집 및 이용안내</Modal.Title>
                </Modal.Header>
                <Modal.Body>{parse(content.replaceAll('\n', '<br />'))}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )

};

export default TermsModal;
